import {JiraApiConnection, JiraApiKey} from '@package/shared'
import type {z} from 'zod'

export const FormValues = JiraApiConnection.pick({
  name: true,
  domain: true,
  projectKey: true,
  username: true,
  projectId: true,
}).extend({
  apiKey: JiraApiKey,
})
export type FormValues = z.infer<typeof FormValues>
